import React, { useEffect, useState } from "react";
import { Heart } from "lucide-react";
import { toast } from "sonner";
import { mk } from "../../lib/market";

let cache = null;
let owner = null;
let local = new Map();
const subs = new Set();
const who = () => localStorage.getItem("lif_market_token") || "user";
const emit = () => subs.forEach((f) => f(new Set(cache)));

export function useSavedIds() {
  const [ids, setIds] = useState(() => new Set(cache || []));
  useEffect(() => {
    subs.add(setIds);
    if (cache === null || owner !== who()) {
      cache = new Set();
      owner = who();
      local = new Map();
      emit();
      mk.get("/market/saved").then((r) => {
        // taps made while loading are applied on top of the server list
        cache = new Set(r.data.map((l) => l.listing_id));
        local.forEach((on, id) => (on ? cache.add(id) : cache.delete(id)));
        emit();
      }).catch(() => { cache = null; });
    }
    return () => subs.delete(setIds);
  }, []);
  return ids;
}

export function SaveButton({ id, big = false }) {
  const ids = useSavedIds();
  const on = ids.has(id);
  async function toggle(e) {
    e.preventDefault();
    e.stopPropagation();
    try {
      const { data } = await mk.post(`/market/listings/${id}/save`);
      local.set(id, data.saved);
      cache = new Set(cache || []);
      data.saved ? cache.add(id) : cache.delete(id);
      emit();
      if (data.saved) toast.success("Saved. We'll email you if the price drops");
    } catch (e) { toast.error(e?.response?.status === 401 ? "Confirm your email at the top of the marketplace to save items" : "Couldn't save. Try again"); }
  }
  return (
    <button onClick={toggle} aria-pressed={on} aria-label={on ? "Remove from saved" : "Save"} data-testid={`save-listing-${id}`}
      className={big ? "btn-outline-gold w-full" : "absolute top-3 right-3 w-9 h-9 rounded-full bg-white/90 flex items-center justify-center shadow transition-transform hover:scale-110"}>
      <Heart className={`w-4 h-4 ${on ? "fill-[#d41a24] text-[#d41a24]" : ""}`} />{big && (on ? " Saved" : " Save for later")}
    </button>
  );
}
